import orderAPI from '../../api/PreOrderSheets'
import * as types from '../mutation-types'

// STATE
const state = {
    PreOrderSheets: [],
    PreOrderSheet: {},
    PreOrderSheetProducts: {},
    PreOrderSheetMarketingProducts: {},
    BrandsOptions: [],
    CollectionOptions: [],
    TargetOptions: [],
    TargetSelected: [],
    ProductGroupSelected: [],
    ProductSelected: [],
    MarketingGroupSelected: [],
    MarketingSelected: [],
    PreOrderSheetsFilters: [],
    PreOrderSheetsPagination: {}
}

// GETTERS
const getters = {
    PreOrderSheets: state => state.PreOrderSheets,
    PreOrderSheet: state => state.PreOrderSheet,
    PreOrderSheetProducts: state => state.PreOrderSheetProducts,
    PreOrderSheetMarketingProducts: state => state.PreOrderSheetMarketingProducts,
    BrandsOptions: state => state.BrandsOptions,
    CollectionOptions: state => state.CollectionOptions,
    TargetOptions: state => state.TargetOptions,
    TargetSelected: state => state.TargetSelected,
    ProductGroupSelected: state => state.ProductGroupSelected,
    ProductSelected: state => state.ProductSelected,
    MarketingGroupSelected: state => state.MarketingGroupSelected,
    MarketingSelected: state => state.MarketingSelected,
    PreOrderSheetsFilters: state => state.PreOrderSheetsFilters,
    PreOrderSheetsPagination: state => state.PreOrderSheetsPagination
}

// ACTIONS
const actions = {
    // PREORDERSHEET LIST
    getPreOrderSheets({ commit }, params) {
        return new Promise((resolve, reject) => {
            orderAPI.getPreOrderSheets(sheets => {
                commit(types.RECEIVE_SHEETS, { sheets })
                resolve(sheets)
            }, params)
        })
    },
    copyPreOrderSheet({ commit }, id) {
        return new Promise((resolve, reject) => {
            orderAPI.copyPreOrderSheet(newId => {
                resolve(newId)
            }, id)
        })
    },

    // PREORDERSHEET
    createPreOrderSheet({ commit }, PreOrderSheet) {
        return new Promise((resolve, reject) => {
            orderAPI.createPreOrderSheet(sheet => {
                commit(types.SEND_NEW_SHEET, { sheet })
                resolve(sheet)
            }, PreOrderSheet)
        })
    },
    getPreOrderSheet({ commit }, id) {
        return new Promise((resolve, reject) => {
            orderAPI.getPreOrderSheet(sheet => {
                commit(types.RECEIVE_SHEET, { sheet })

                if (sheet.Targets) {
                    commit(types.RECEIVE_TARGET_SELECTED, { targets: sheet.Targets })
                }
                if (sheet.ProductGroups) {
                    commit(types.RECEIVE_PRODUCT_GROUP_SELECTED, { productGroups: sheet.ProductGroups })
                }
                if (sheet.MarketingProductGroups) {
                    commit(types.RECEIVE_MARKETING_GROUP_SELECTED, { marketingProductGroups: sheet.MarketingProductGroups })
                }

                resolve(sheet)
            }, id)
        })
    },
    getPreOrderSheetProducts({ commit }, params) {
      return new Promise((resolve, reject) => {
        orderAPI.getPreOrderSheetProducts(sheet => {
          commit(types.RECEIVE_SHEET_PRODUCTS, { sheet })

          if (sheet.Targets) {
            commit(types.RECEIVE_TARGET_SELECTED, { targets: sheet.Targets })
          }
          if (sheet.ProductGroups) {
            commit(types.RECEIVE_PRODUCT_GROUP_SELECTED, { productGroups: sheet.ProductGroups })
          }
          resolve(sheet)
        }, params)
      })
    },
    getPreOrderSheetMarketingProducts({ commit }, params) {
      return new Promise((resolve, reject) => {
        orderAPI.getPreOrderSheetMarketingProducts(sheet => {
          commit(types.RECEIVE_SHEET_MARKETING_PRODUCTS, { sheet })

          if (sheet.Targets) {
            commit(types.RECEIVE_TARGET_SELECTED, { targets: sheet.Targets })
          }
          if (sheet.ProductGroups) {
            commit(types.RECEIVE_PRODUCT_GROUP_SELECTED, { productGroups: sheet.ProductGroups })
          }
          resolve(sheet)
        }, params)
      })
    },
    updatePreOrderSheet({ commit }, params) {
        return new Promise((resolve, reject) => {
            orderAPI.updatePreOrderSheet(order => {
                resolve(order)
            }, params)
        })
    },

    // BRANDS & COLLECTIONS
    getBrandsOptions({ commit }) {
        return new Promise((resolve, reject) => {
            orderAPI.getBrands(brands => {
                commit(types.RECEIVE_BRANDS, { brands })
                resolve(brands)
            })
        })
    },
    getCollectionsOptions({ commit }, params) {
        return new Promise((resolve, reject) => {
            orderAPI.getCollections(collections => {
                commit(types.RECEIVE_COLLECTIONS, { collections })
                resolve(collections)
            }, params)
        })
    },

    // PRODUCT GROUP
    sendGroupToSheet({ commit }, params) {
        return new Promise((resolve, reject) => {
            orderAPI.addProductGroupToSheet(group => {
                resolve(group)
            }, params)
        })
    },
    updateGroupToSheet({ commit }, params) {
        return new Promise((resolve, reject) => {
            orderAPI.updateProductGroupToSheet(group => {
                resolve(group)
            }, params)
        })
    },
    updateGroupSortIndexToSheet({ commit }, params) {
        return new Promise((resolve, reject) => {
            orderAPI.updateProductGroupSortIndexToSheet(group => {
                resolve(group)
            }, params)
        })
    },
    deleteProductGroupFromSheet ({ commit }, params) {
        return new Promise((resolve, reject) => {
            orderAPI.removeProductGroupFromSheet(group => {
                resolve()
            }, params)
        })
    },

    // PRODUCT
    sendProductToSheet({ commit }, params) {
        return new Promise((resolve, reject) => {
            orderAPI.addProductToSheet(product => {
                resolve(product)
            }, params)
        })
    },
    updateProductInSheet({ commit }, params) {
        return new Promise((resolve, reject) => {
            orderAPI.updateProductInSheet(group => {
                resolve(group)
            }, params)
        })
    },
    deleteProductFromSheet ({ commit }, params) {
        commit(types.DELETE_PRODUCT_FROM_SHEET, { params })
        return new Promise((resolve, reject) => {
            orderAPI.removeProductFromSheet(product => {
                resolve(product)
            }, params)
        })
    },

    // PRODUCT VARIANT
    updateProductVariant({ commit }, params) {
        return new Promise((resolve, reject) => {
            orderAPI.updateProductVariant(group => {
                resolve(group)
            }, params)
        })
    },

    // MARKETING GROUP
    sendMarketingGroupToSheet({ commit }, params) {
        return new Promise((resolve, reject) => {
            orderAPI.addMarketingGroupToSheet(group => {
                resolve(group)
            }, params)
        })
    },
    updateMarketingGroupToSheet({ commit }, params) {
        return new Promise((resolve, reject) => {
            orderAPI.updateMarketingGroupToSheet(group => {
                resolve(group)
            }, params)
        })
    },
    deleteMarketingGroupFromSheet ({ commit }, params) {
        return new Promise((resolve, reject) => {
            orderAPI.removeMarketingGroupFromSheet(group => {
                resolve(group)
            }, params)
        })
    },

    // MARKETING PRODUCT
    sendMarketingToSheet({ commit }, params) {
        return new Promise((resolve, reject) => {
            orderAPI.addMarketingToSheet(product => {
                resolve(product)
            }, params)
        })
    },
    updateMarketingInSheet({ commit }, params) {
        return new Promise((resolve, reject) => {
            orderAPI.updateMarketingInSheet(group => {
                resolve(group)
            }, params)
        })
    },
    deleteMarketingFromSheet ({ commit }, params) {
        commit(types.DELETE_MARKETING_FROM_SHEET, { params })
        return new Promise((resolve, reject) => {
            orderAPI.removeMarketingFromSheet(product => {
                resolve(product)
            }, params)
        })
    },

    // TARGET OPTIONS TO SHEET
    getTargetOptions({ commit }) {
        return new Promise((resolve, reject) => {
            orderAPI.getPreOrdersSheetSearch(targets => {
                commit(types.RECEIVE_TARGETS, { targets })
                resolve(targets)
            })
        })
    },
    setTargetOptions({ commit }, targets) {
        commit(types.RECEIVE_TARGET_SELECTED, { targets })
    },

    // PREORDER SHEET REPORTING
    getSheetBaseData({ commit }, sheetId) {
        return new Promise((resolve) => {
            orderAPI.getSheetBaseData(sheet => {
                resolve(sheet)
            }, sheetId)
        })
    },
    getSheetStats({ commit }, params) {
        return new Promise((resolve) => {
            orderAPI.getSheetStats(sheet => {
                resolve(sheet)
            }, params.sheetId, params.salesmanId, params.country)
        })
    },
    downloadExport({ commit }, params) {
        return new Promise((resolve) => {
            orderAPI.downloadExport(csv => {
                resolve(csv)
            }, params.sheetId, params.salesmanId, params.country)
        })
    }
}

// MUTATIONS
const mutations = {
    [types.RECEIVE_SHEETS] (state, { sheets }) {
        state.PreOrderSheets = sheets.PreOrderSheets
        state.PreOrderSheetsFilters = sheets.Filters
        state.PreOrderSheetsPagination = {
            PageStartIndex: sheets.PageStartIndex,
            PageEndIndex: sheets.PageEndIndex,
            Pages: sheets.Pages,
            TotalCount: sheets.TotalCount,
            PageCount: sheets.PageCount
        }
    },
    [types.SEND_NEW_SHEET] (state, { sheet }) {
        state.PreOrderSheet = sheet
    },
    [types.RECEIVE_SHEET] (state, { sheet }) {
        state.PreOrderSheet = sheet
    },
    [types.RECEIVE_SHEET_PRODUCTS] (state, { sheet }) {
      state.PreOrderSheetProducts = sheet
    },
    [types.RECEIVE_SHEET_MARKETING_PRODUCTS] (state, { sheet }) {
      state.PreOrderSheetMarketingProducts = sheet
    },

    [types.RECEIVE_BRANDS] (state, { brands }) {
        let responseBrands = [];
        brands.forEach((brand, index) => {
            responseBrands.push({
                Id: brand.Id,
                Name: brand.Name,
                Code: brand.Code
            });
        });
        state.BrandsOptions = responseBrands;
    },
    [types.RECEIVE_COLLECTIONS] (state, { collections }) {
        state.CollectionOptions = collections;
    },

    [types.RECEIVE_TARGETS] (state, { targets }) {
        let responseTargets = [];
        targets.forEach((target, index) => {
            responseTargets.push({
                TargetId: target.Id,
                TargetName: target.Name,
                MaximumDiscount: target.MaximumDiscount
            });
        });
        state.TargetOptions = responseTargets;
    },
    [types.RECEIVE_TARGET_SELECTED] (state, { targets }) {
        state.TargetSelected = targets;
        state.PreOrderSheet.Targets = targets;
    },
    [types.DELETE_PRODUCT_FROM_SHEET] (state, { params }) {
        let productIndex = state.PreOrderSheetProducts.ProductGroups[params.groupIndex].Products.findIndex(p => p.Id === params.productId);
        state.PreOrderSheetProducts.ProductGroups[params.groupIndex].Products.splice(productIndex, 1);
    },
    [types.RECEIVE_PRODUCT_GROUP_SELECTED] (state, { productGroups }) {
        let products = [];

        state.ProductGroupSelected = productGroups.map((productGroup) => {
            productGroup.Products.map((product) => {
                products.push(product.ProductId);
            });
            return productGroup.ProductGroupId;
        });

        state.ProductSelected = products;
    },
    [types.DELETE_MARKETING_FROM_SHEET] (state, { params }) {
        let productIndex = state.PreOrderSheetMarketingProducts.MarketingProductGroups[params.groupIndex].Products.findIndex(p => p.Id === params.productId);
        state.PreOrderSheetMarketingProducts.MarketingProductGroups[params.groupIndex].Products.splice(productIndex, 1);
    },
    [types.RECEIVE_MARKETING_GROUP_SELECTED] (state, { marketingProductGroups }) {
        let marketingProducts = [];

        if (marketingProductGroups) {
            state.MarketingProductGroups = marketingProductGroups.map((marketingProductGroup) => {
                marketingProductGroup.Products.map((product) => {
                    marketingProducts.push(product.ProductId);
                });
                return marketingProductGroup.ProductGroupId;
            });
        }

        state.MarketingSelected = marketingProducts;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/PreOrderSheets.js